import dayjs from 'dayjs'
import { relationship } from 'consts'
import { dateFormat } from 'consts'

const deserializeSex = sex => {
  if (!sex) return null
  if (sex === 'M') return 'male'
  if (sex === 'F') return 'female'
}

const deserializeDate = date => {
  if (!date) return null
  const parsedDate = dayjs(date)

  return parsedDate.format(dateFormat)
}

const deserializeAddress = address => {
  if (!address) return null
  return {
    state: address.state?.state_name_short,
    zipCode: address.zip_code,
    county: address.county?.county_name,
    city: address.city,
    address1: address.street_address_1,
    address2: address.street_address_2
  }
}

const getIsHomeAddressAsOwner = enrollee => {
  return (
    enrollee.relationship_status !== relationship.owner &&
    !enrollee.mailing_address
  )
}
const getIsMailingAddressAsOwner = enrollee => {
  return (
    enrollee.relationship_status !== relationship.owner &&
    !enrollee.billing_address
  )
}

export const deserializeEnrolles = ({ enrollees }) => {
  return enrollees.map(enrollee => {
    const isMailingAddressAsHomeAddress = !enrollee.billing_address
    const mailingAddress = deserializeAddress(enrollee.billing_address)

    return {
      id: enrollee.id,
      firstName: enrollee.first_name,
      lastName: enrollee.last_name,
      ssn: null, // ssn is not available in the response and handles in the UI
      ssnLast4: enrollee.ssn_last_4,
      dob: deserializeDate(enrollee.date_of_birth),
      sex: deserializeSex(enrollee.sex),
      // if the value is null, we should set it to false
      isTobbacoUser: enrollee.tobacco_user || false,
      isElligible: enrollee.coverage_eligible || false,
      phone: enrollee.phone,
      email: enrollee.email,
      relation: enrollee.relationship_status,
      homeAddress: deserializeAddress(enrollee.mailing_address),
      mailingAddress: mailingAddress,
      isMailingAddressAsHomeAddress: isMailingAddressAsHomeAddress,
      isHomeAddressAsOwner: getIsHomeAddressAsOwner(enrollee),
      isMailingAddressAsOwner: getIsMailingAddressAsOwner(enrollee),
      prefferedLanguage: enrollee.language
    }
  })
}

export const deserializeQualifyEvent = ({ data }) => {
  const { enrollment_reason, coverage_start_date } = data
  if (!enrollment_reason) {
    return {
      reason: null,
      date: null,
      coverageStartDate: deserializeDate(coverage_start_date)
    }
  } else {
    return {
      reason: enrollment_reason?.reason,
      date: deserializeDate(enrollment_reason?.qualifying_life_event_date),
      coverageStartDate: deserializeDate(coverage_start_date)
    }
  }
}
